/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import 'webc';
import 'hammerjs';

import {enableProdMode} from '@angular/core';
import {environment} from '~local/environments/environment';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from '~local/app/app.component';

import {appConfig} from '~local/app/app.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
